// extracted by mini-css-extract-plugin
module.exports = {"proPriceLogin":"LoginForProPriceLabel_proPriceLogin__X9Bx3","proPriceLogin__link":"LoginForProPriceLabel_proPriceLogin__link__JoVux"};